<template>
  <div class="right-nav">
    <ul>
      <li class="right-nav-item" @click="goHome">
        <div class="right-nav-item-content">
          <i class="icon iconfont iconhome"></i>
          <span>首页</span>
        </div>
      </li>
      <!-- <li class="right-nav-item">
        <div class="right-nav-item-content">
          <i class="icon iconfont iconshezhi">
          </i>
          <span>成员管理</span>
        </div>
      </li>
      <li class="right-nav-item">
        <div class="right-nav-item-content">
          <i class="icon iconfont iconhoutaiweihu"></i>
          <span>最新动态</span>
        </div>
      </li> -->
      <li class="right-nav-item">
        <div class="right-nav-item-content" @click="top()">
          <i class="icon iconfont iconmd-arrow-up"></i>
          <span>返回顶部</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    goHome() {
      this.$router.push({ path: '/home' });
    },
    top() {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.top);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/common/adminArea/right-nav.vue